import i18n from "@/i18n";

import { CustomFilter } from "@/types/custom-filter";

import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Boolean text filter
 */
export const booleanTextFilter: CustomFilter = {
  booleanText(value: any): string {
    if (+value) {
      value = i18n.t(I18nMessageKey.SharedFiltersBooleanTextYesText);
    } else {
      value = i18n.t(I18nMessageKey.SharedFiltersBooleanTextNoText);
    }
    return value;
  }
};
